import { ClientApi } from '@ssv-website/hooks';
import type {
  ConferenceApiResponse,
  ConferenceIndustryPartnerDetail,
  ConferenceRegisterPayload,
  ConferenceRegisterResult,
  ConferenceIndustryPartnerUpdateResult,
} from './types';

const CONFERENCE_INDUSTRY_PARTNER_API_PREFIX =
  '/portalWebAPI/conference/industryPartner';
const CONFERENCE_INDUSTRY_PARTNER_DETAIL_API =
  `${CONFERENCE_INDUSTRY_PARTNER_API_PREFIX}/detail`;
const CONFERENCE_INDUSTRY_PARTNER_REGISTER_API =
  `${CONFERENCE_INDUSTRY_PARTNER_API_PREFIX}/register`;
const CONFERENCE_INDUSTRY_PARTNER_UPDATE_API =
  `${CONFERENCE_INDUSTRY_PARTNER_API_PREFIX}/update`;

export const CONFERENCE_DUPLICATE_REGISTER_MESSAGE =
  '您已提交过行业伙伴信息，请勿重复提交';

export const getConferenceIndustryPartnerDetail = async () => {
  // ClientApi.post 会自动解包后端 TBaseRsp.data，这里重新包装成页面状态机需要的响应结构。
  const data = await ClientApi.post(
    CONFERENCE_INDUSTRY_PARTNER_DETAIL_API,
    {},
    {
      cache: 'no-store',
      errorMessage: false,
    }
  );

  return {
    code: 0,
    msg: '',
    data,
  } as ConferenceApiResponse<ConferenceIndustryPartnerDetail>;
};

export const registerConferenceIndustryPartner = (
  payload: ConferenceRegisterPayload
) =>
  ClientApi.post(
    CONFERENCE_INDUSTRY_PARTNER_REGISTER_API,
    payload
  ) as Promise<ConferenceRegisterResult>;

export const updateConferenceIndustryPartner = (
  payload: ConferenceRegisterPayload
) =>
  ClientApi.post(
    CONFERENCE_INDUSTRY_PARTNER_UPDATE_API,
    payload
  ) as Promise<ConferenceIndustryPartnerUpdateResult>;
